import { styled } from '@cp/ds/src/theme';
import { ComponentType } from 'react';
import { BoxProps } from '@cp/ds/src/components/box';
import { CatalogList } from './catalogList';

const name = 'CatalogFlexList';
export const CatalogFlexList = styled(CatalogList, { name })(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
})) as unknown as ComponentType<BoxProps>;
